import moment from "moment-timezone";

export const isJsonString = (str) => {
  if (str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
};

export function rangeDesc(start, end) {
  return Array(start - end + 1)
    .fill()
    .map((_, idx) => start - idx);
}

export const today = moment().tz("Asia/Ho_Chi_Minh").format("YYYY-MM-DD");

export const downloadFile = (file, name, typeFile = 'txt') => {
  const url = window.URL.createObjectURL(new Blob([file], { type: 'text/plain' }));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${name}.${typeFile}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
